import { render, staticRenderFns } from "./AddTaskModal.vue?vue&type=template&id=1e4234b8&"
import script from "./AddTaskModal.vue?vue&type=script&lang=js&"
export * from "./AddTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports